import React, { useEffect, useRef, useState, useCallback } from 'react';
import Hero from "./components/Hero";
import Atlantico from "./components/atlantico/Home.jsx";
import Sponsors from "./components/sponsors/Sponsors";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import SponsorsContact from "./components/sponsors/SponsorsContact";
import News from "./components/news/Home.jsx";
import EventsSection from "./components/events/Home.jsx";

function Home() {
  const [activeSection, setActiveSection] = useState('');
  const sectionsRef = useRef({});
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const setSectionRef = useCallback((node) => {
    if (node !== null) {
      sectionsRef.current[node.id] = node;
    }
  }, []);

  useEffect(() => {
    if (imagesLoaded) {
      const options = {
        root: null,
        rootMargin: '-50% 0px', 
        threshold: 0, 
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const sectionId = entry.target.id;
            setActiveSection(sectionId);
          }
        });
      }, options);

      const currentSections = sectionsRef.current;
      Object.values(currentSections).forEach(section => {
        observer.observe(section);
      });

      return () => {
        Object.values(currentSections).forEach(section => {
          observer.unobserve(section);
        });
      };
    }
  }, [imagesLoaded]);

  useEffect(() => {
    const handleImageLoad = () => {
      const images = document.querySelectorAll('img');
      const allImagesLoaded = Array.from(images).every(img => img.complete && img.naturalHeight !== 0);
      if (allImagesLoaded) {
        setImagesLoaded(true);
      }
    };

    const images = document.querySelectorAll('img');
    images.forEach(img => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
        img.addEventListener('error', handleImageLoad);
      }
    });

    return () => {
      images.forEach(img => {
        img.removeEventListener('load', handleImageLoad);
        img.removeEventListener('error', handleImageLoad);
      });
    };
  }, []);

  if (!imagesLoaded) {
    return <Loading />;
  }

  return (
    <>
      <NavBar activeSection={activeSection} />
      <div className="overflow-y-scroll h-screen z-0 scroll-smooth overflow-x-hidden">
        <section ref={setSectionRef} className="hero-bg w-full snap-center" id="team">
          <Hero />
        </section>

        <section ref={setSectionRef} id="atlantico" className="snap-center">
          <Atlantico />
        </section>

        <section ref={setSectionRef} id="events" className="snap-center">
          <EventsSection />
        </section>
        <section ref={setSectionRef} id="news" className="snap-center">
          <News />
        </section>
        <section ref={setSectionRef} id="sponsors" className="snap-center">
          <Sponsors />
        </section>
         <section id="support-us">
           <SponsorsContact />
         </section>
        <section ref={setSectionRef} className="w-full snap-center" id="footer">
          <Footer />
        </section>
      </div>
    </>
  );
}

export default Home;
